import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';
import { RESPONSE_TYPES } from '_helpers/handlers';

const { handleResponseAsync } = handlers;

async function downloadConfig(machineID, datetime) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/configs/${machineID}${datetime ? `?datetime=${datetime}` : ''}`
      })),
    RESPONSE_TYPES.FILE_DOWNLOAD,
  );
}

async function downloadDatagram(machineID, datetime) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/configs/datagram/${machineID}${datetime ? `?datetime=${datetime}` : ''}`
      })),
    RESPONSE_TYPES.FILE_DOWNLOAD,
  );
}

// NOTE: We need to test that downloading config still works. Removed handle file response.
async function downloadLicense(machineID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/licenseJournals/${machineID}/download`
      })),
    RESPONSE_TYPES.FILE_DOWNLOAD,
  );
}

// NOTE: We need to test that downloading config still works. Removed handle file response.
async function downloadLicenseDatagram(machineID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/licenseJournals/${machineID}/downloadDatagram`
      })),
    RESPONSE_TYPES.FILE_DOWNLOAD,
  );
}

async function getMinePlanFileLink(minePlanID) {
  return handleResponseAsync(
    await crFetch({
      method: 'GET',
      url: `/mineplans/${minePlanID}/downloadLink`,
    })
  );
}

// NOTE: We need to test that uploading still works. Not sure it's been tested since conversion.
async function uploadLicenseEnvelope(file) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/licenseJournals/UploadDatagram',
        body: file,
        multipart: true
      }))
  );
}

// NOTE: We need to test that uploading still works. Not sure it's been tested since conversion.
async function uploadConfig(machineID, file) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: `/configs/${machineID}`,
        body: file,
        multipart: true
      }))
  );
}

const transferService = {
  downloadConfig,
  downloadDatagram,
  downloadLicense,
  downloadLicenseDatagram,
  uploadLicenseEnvelope,
  uploadConfig,
  getMinePlanFileLink,
};

export default transferService;
